import React from "react";

export default function Icons_Reference() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Icons_Reference</h2>
      <p>Route: /icons/reference</p>
    </div>
  );
}
